import { api } from "./api";
const apiUrl = "https://admin.bcuni.eu/api";
const extendedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    addLessonVideo: builder.mutation({
      query: (data) => ({
        url: `${apiUrl}/lesson-video/add`,
        method: "POST",
        body: { data },
        credentials: "include",
      }),
    }),
    getLessonVideos: builder.query({
      query: (data) => ({
        url: `${apiUrl}/lesson-video/list`,
        method: "POST",
        body: { data },
        credentials: "include",
      }),
    }),
    getStudentLessonVideos: builder.query({
      query: (data) => ({
        url: `${apiUrl}/lesson-video/student/list`,
        method: "POST",
        body: { data },
        credentials: "include",
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddLessonVideoMutation,
  useGetLessonVideosQuery,
  useGetStudentLessonVideosQuery,
} = extendedApi;
